import styled from '@emotion/styled';
import ReplyIcon from './ReplyIcon';
import { lighten } from '@mui/system';
import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';

type ReplyIndicatorProps = {
  isPurple?: boolean;
};

const StyledIndicator = styled('figure')<ReplyIndicatorProps>(
  {
    position: 'absolute',
    top: 0,
    left: 0,
    margin: 0,
    width: 24,
    height: 24,
    transform: 'rotate(180deg)',
  },
  ({ theme, isPurple }) => {
    if (isPurple) {
      return {
        color: theme.isDark
          ? lighten(theme.palette.sliders.coach, 0.4)
          : theme.palette.sliders.coach,
      };
    }

    return {
      color: theme.palette.text.primary,
    };
  },
  addHighContrastStyles(({ theme }) => ({
    color: theme.palette.text.primary,
  })),
);

const ReplyIndicator = ({ isPurple }: ReplyIndicatorProps) => (
  <StyledIndicator isPurple={isPurple}>
    <ReplyIcon />
  </StyledIndicator>
);

export default ReplyIndicator;
